var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _vm.selection.type === "email"
    ? _c("add-forwarder", {
        on: {
          "set-domain": _vm.setDomain,
          close: _vm.triggerAddForwarder,
          "action-completed": _vm.getForwarders
        }
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }